import { handleActions } from 'redux-actions';

import { NAMES as CHANNEL_VIDEOS_LAZY_LIST } from 'widget/redux/client/actions/channel-videos-lazy-load';
import { NAMES as CHANNEL_VIDEOS_LIST } from 'widget/redux/server/actions/channel/videos/list-public';


const paginatedVideosDefaults = {
  videoIds: [],
  nextVideosCursor: null,
  category: null, // TODO: combine category and nextVideoCursor in one property
};

function saveIds(state, { payload }) {
  const ids = _(state.videoIds)
    .concat(payload.response.data.result)
    .uniq()
    .value();

  return {
    ...state,
    videoIds: ids,
    nextVideosCursor: payload.response.paging.cursor,
  };
}

function resetVideos(state) {
  return {
    ...state,
    videoIds: paginatedVideosDefaults.videoIds,
    nextVideosCursor: paginatedVideosDefaults.nextVideosCursor,
  };
}

function setCategory(state, { payload }) {
  return {
    ...state,
    category: payload,
  };
}

function resetCategory(state) {
  return {
    ...state,
    category: paginatedVideosDefaults.category,
  };
}

export default handleActions({
  [CHANNEL_VIDEOS_LAZY_LIST.VIDEOS_RESET]: resetVideos,
  [CHANNEL_VIDEOS_LAZY_LIST.CATEGORY_UPDATE]: setCategory,
  [CHANNEL_VIDEOS_LAZY_LIST.CATEGORY_RESET]: resetCategory,
  [CHANNEL_VIDEOS_LIST.SUCCESS]: saveIds,
}, paginatedVideosDefaults);



// WEBPACK FOOTER //
// ./src/widget/redux/client/reducers/channel-videos-lazy-load.js